import styled from 'styled-components';

const InputRadio = styled.input`
  margin-right: 1rem;
  margin-top: ${({ mt }) => mt && '1rem'}
`;

export default InputRadio;
